/**
 * usePortalAccess.js
 * =================
 * TASK 112 - the role half of the "who sees a locked feature" decision, read
 * straight from the authenticated user in redux.
 *
 * Used by `UpgradePrompt` (every gate funnels through it) and by `SellerLayout`
 * (the nav), so the ACCOUNT user / SELLER user split has exactly ONE definition
 * (`src/utils/portalAccess.js`) and no component re-derives it.
 */

import { useSelector } from 'react-redux';
import {
  isAccountUser,
  isSellerUser,
  viewerKindOf,
  canOfferUpgrade,
  upgradePathFor,
} from '../utils/portalAccess';

export const usePortalAccess = () => {
  const user = useSelector((state) => state?.loyalty?.admin?.user);

  return {
    user,
    viewerKind: viewerKindOf(user),
    isAccountUser: isAccountUser(user),
    isSellerUser: isSellerUser(user),
    canOfferUpgrade: canOfferUpgrade(user),
    upgradePath: upgradePathFor(user),
  };
};

export default usePortalAccess;
